import { Link } from "react-router-dom";

export default function Footer() {
  const footerLinks = [
    {
      title: "观看分类",
      links: [
        { label: "热门推荐", href: "/category/recommend" },
        { label: "最新上映", href: "/category/new-release" },
        { label: "电影", href: "/category/movie" },
        { label: "电视剧", href: "/category/tv-series" },
      ],
    },
    {
      title: "更多内容",
      links: [
        { label: "综艺", href: "/category/variety" },
        { label: "动漫", href: "/category/anime" },
        { label: "纪录片", href: "/category/documentary" },
        { label: "少儿", href: "/category/kids" },
      ],
    },
    {
      title: "关于我们",
      links: [
        { label: "品牌介绍", href: "/about" },
        { label: "用户口碑", href: "/about" },
        { label: "联系我们", href: "/about" },
        { label: "首页", href: "/" },
      ],
    },
  ];

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-bold text-background-50">17.c 起草</span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              17.c 起草在线观看免费版——您的专属影视在线观看平台。海量资源、高清画质、流畅播放，随时随地享受精彩影视内容。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 text-background-50 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 text-background-50 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 text-background-50 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-base"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-foreground-400 hover:text-primary-300 text-sm transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; 2026 17.c 起草在线观看免费版. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-foreground-300 text-xs transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-foreground-500 hover:text-foreground-300 text-xs transition-colors cursor-pointer whitespace-nowrap">服务条款</a>
            <a href="#" className="text-foreground-500 hover:text-foreground-300 text-xs transition-colors cursor-pointer whitespace-nowrap">帮助中心</a>
          </div>
        </div>
      </div>
    </footer>
  );
}